import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ADDRESS_FEATURE, AddressState } from './address.state';

export class AddressSelectors {
    public static getAddressState = createFeatureSelector<AddressState>(ADDRESS_FEATURE);

    public static getAddress = createSelector(AddressSelectors.getAddressState, (state: AddressState) => state.address);
}
